import { jwtDecode } from 'jwt-decode';

interface TokenPayload {
  exp: number;
  iat?: number;
  sub?: string;
  email?: string;
  name?: string;
  role?: string;
  [key: string]: any; // permite campos personalizados
}

export function isTokenValid(token: string | null | undefined): boolean {
  if (!token) return false;

  try {
    const payload = jwtDecode<TokenPayload>(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp > currentTime;
  } catch {
    return false;
  }
}

export function getTokenPayload<T = TokenPayload>(token: string | null | undefined): T | null {
  if (!token) return null;

  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
}
